const state = {
    visitedViewsList: [],
    cachedViewsList: []
  }
  
  const mutations = {
    ADD_VISITED_VIEW: (state, view) => {
      if (state.visitedViewsList.some(v => v.path === view.path)) return
      state.visitedViewsList.push(
        Object.assign({}, view, {
          title: view.meta.anotherName || 'no-name'
        })
      )
    },
    ADD_CACHED_VIEW: (state, view) => {
      if (state.cachedViewsList.includes(view.name)) return
      if (!view.meta.noCache) {
        state.cachedViewsList.push(view.name)
      }
    },
  
    DEL_VISITED_VIEW: (state, view) => {
      for (const [i, v] of state.visitedViewsList.entries()) {
        if (v.path === view.path) {
          state.visitedViewsList.splice(i, 1)
          break
        }
      }
    },
    DEL_CACHED_VIEW: (state, view) => {
      const index = state.cachedViewsList.indexOf(view.name)
      index > -1 && state.cachedViewsList.splice(index, 1)
    },
  
    DEL_OTHERS_VISITED_VIEWS: (state, view) => {
      state.visitedViewsList = state.visitedViewsList.filter(v => {
        return v.meta.affixType || v.path === view.path
      })
    },
    DEL_OTHERS_CACHED_VIEWS: (state, view) => {
      const index = state.cachedViewsList.indexOf(view.name)
      if (index > -1) {
        state.cachedViewsList = state.cachedViewsList.slice(index, index + 1)
      } else {
        state.cachedViewsList = []
      }
    },
  
    DEL_ALL_VISITED_VIEWS: state => {
      // keep affix tags
      const affixTags = state.visitedViewsList.filter(tag => tag.meta.affixType)
      state.visitedViewsList = affixTags
    },
    DEL_ALL_CACHED_VIEWS: state => {
      state.cachedViewsList = []
    },
  
    UPDATE_VISITED_VIEW: (state, view) => {
      for (let v of state.visitedViewsList) {
        if (v.path === view.path) {
          v = Object.assign(v, view)
          break
        }
      }
    },
    Logout_System_View:(state,list)=>{
      state.visitedViewsList=[]
      state.cachedViewsList=[]
    }
  }
  
  const actions = {
    addView({ dispatch }, view) {
      dispatch('addVisitedView', view)
      dispatch('addCachedView', view)
    },
    addVisitedView({ commit }, view) {
      commit('ADD_VISITED_VIEW', view)
    },
    addCachedView({ commit }, view) {
      commit('ADD_CACHED_VIEW', view)
    },
  
    delView({ dispatch, state }, view) {
      return new Promise(resolve => {
        dispatch('delVisitedView', view)
        dispatch('delCachedView', view)
        resolve({
            visitedViewsList: [...state.visitedViewsList],
            cachedViewsList: [...state.cachedViewsList]
        })
      })
    },
    delVisitedView({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_VISITED_VIEW', view)
        resolve([...state.visitedViewsList])
      })
    },
    delCachedView({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_CACHED_VIEW', view)
        resolve([...state.cachedViewsList])
      })
    },
  
    delOthersViews({ dispatch, state }, view) {
      return new Promise(resolve => {
        dispatch('delOthersVisitedViews', view)
        dispatch('delOthersCachedViews', view)
        resolve({
          visitedViewsList: [...state.visitedViewsList],
          cachedViewsList: [...state.cachedViewsList]
        })
      })
    },
    delOthersVisitedViews({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_OTHERS_VISITED_VIEWS', view)
        resolve([...state.visitedViewsList])
      })
    },
    delOthersCachedViews({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_OTHERS_CACHED_VIEWS', view)
        resolve([...state.cachedViewsList])
      })
    },
  
    delAllViews({ dispatch, state }, view) {
      return new Promise(resolve => {
        dispatch('delAllVisitedViews', view)
        dispatch('delAllCachedViews', view)
        resolve({
          visitedViewsList: [...state.visitedViewsList],
          cachedViewsList: [...state.cachedViewsList]
        })
      })
    },
    delAllVisitedViews({ commit, state }) {
      return new Promise(resolve => {
        commit('DEL_ALL_VISITED_VIEWS')
        resolve([...state.visitedViewsList])
      })
    },
    delAllCachedViews({ commit, state }) {
      return new Promise(resolve => {
        commit('DEL_ALL_CACHED_VIEWS')
        resolve([...state.cachedViewsList])
      })
    },
    updateVisitedView({ commit }, view) {
      commit('UPDATE_VISITED_VIEW', view)
    },
    logoutSystemView({ commit }) {
      commit('Logout_System_View', [])
    }
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }
  


// WEBPACK FOOTER //
// ./src/store/modules/tabView.js